export default {
  contracts: [],
  contract: undefined,
};
